import { Path, Svg } from 'react-native-svg'

// eslint-disable-next-line no-relative-import-paths/no-relative-import-paths
import { createIcon } from '../factories/createIcon'

export const [CameraScanAlt, AnimatedCameraScanAlt] = createIcon({
  name: 'CameraScanAlt',
  getIcon: (props) => (
    <Svg fill="none" stroke="currentColor" viewBox="0 0 17 16" {...props}>
      <Path
        d="M5.00016 0.5H2.50016C2.05814 0.5 1.63421 0.675595 1.32165 0.988155C1.00909 1.30072 0.833496 1.72464 0.833496 2.16667V4.66667M15.8335 4.66667V2.16667C15.8335 1.72464 15.6579 1.30072 15.3453 0.988155C15.0328 0.675595 14.6089 0.5 14.1668 0.5H11.6668M11.6668 15.5H14.1668C14.6089 15.5 15.0328 15.3244 15.3453 15.0118C15.6579 14.6993 15.8335 14.2754 15.8335 13.8333V11.3333M0.833496 11.3333V13.8333C0.833496 14.2754 1.00909 14.6993 1.32165 15.0118C1.63421 15.3244 2.05814 15.5 2.50016 15.5H5.00016"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  ),
})
